import { cx } from '@/shared/lib/cx';

import styles from './spinner.module.scss';

export function Spinner({
  tone = 'light',
  size = 14,
  className,
}: {
  tone?: 'light' | 'dark';
  size?: 14 | 16;
  className?: string | undefined;
}) {
  return (
    <span
      className={cx(styles.root, className)}
      data-tone={tone}
      data-size={size}
      aria-hidden="true"
    />
  );
}
